<template>
    <div>
      <gamesheet :gameId=this.gameId :period=0 :gameInfo=this.gameInfo :team=0></gamesheet>
      <gamesheet :gameId=this.gameId :period=0 :gameInfo=this.gameInfo :team=1></gamesheet>
    </div>
    </template>
    
    <script>
    import GameSummary from './match-summary.vue'
    import Gamesheet from './gamesheet-dynamic.vue'
    export default {
      components: {
        'game-summary': GameSummary,
        'gamesheet': Gamesheet
      },
      data: function () {
        return {
          period: 0,
          gameId: 0,
          gameInfo: {
          }
        }
      },
      methods: {
        getGameData: function () {
          this.$http.get(
            'https://devilsapi.roblutken.com/api/games/get/single/' + this.gameId,
            { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
          ).then(res => {
            this.gameInfo = res
            this.gameInfo = this.gameInfo['data'][0]
            console.log('Response for game was: ' + JSON.stringify(this.gameInfo.home_team.name))
          })
        }
      },
      mounted: function () {
        this.period = parseInt(this.$route.params.period)
        this.gameId = parseInt(this.$route.params.gameId)
        this.getGameData()
      }
    }
    </script>
    
    <style>
    
    </style>



// WEBPACK FOOTER //
// GB-TOI.vue?d06d5194